import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import useScrollToBottom from "./use-scroll-to-bottom";
export function useMessages(t0) {
  const $ = _c(15);
  const {
    chatId,
    status
  } = t0;
  const {
    containerRef,
    endRef,
    isAtBottom,
    scrollToBottom,
    onViewportEnter,
    onViewportLeave
  } = useScrollToBottom();
  const [hasSentMessage, setHasSentMessage] = useState(false);
  let t1;
  let t2;
  if ($[0] !== chatId || $[1] !== scrollToBottom) {
    t1 = () => {
      if (chatId) {
        scrollToBottom("instant");
        setHasSentMessage(false);
      }
    };
    t2 = [chatId, scrollToBottom];
    $[0] = chatId;
    $[1] = scrollToBottom;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== status) {
    t3 = () => {
      if (status === "submitted") {
        setHasSentMessage(true);
      }
    };
    t4 = [status];
    $[4] = status;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== containerRef || $[8] !== endRef || $[9] !== hasSentMessage || $[10] !== isAtBottom || $[11] !== onViewportEnter || $[12] !== onViewportLeave || $[13] !== scrollToBottom) {
    t5 = {
      containerRef,
      endRef,
      isAtBottom,
      scrollToBottom,
      onViewportEnter,
      onViewportLeave,
      hasSentMessage
    };
    $[7] = containerRef;
    $[8] = endRef;
    $[9] = hasSentMessage;
    $[10] = isAtBottom;
    $[11] = onViewportEnter;
    $[12] = onViewportLeave;
    $[13] = scrollToBottom;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}